import React from "react";
import TestimonialCard from "./TestimonialCard";

export default function Testimonials() {
  return (
    <div className="testimonial-wrapper">
      <TestimonialCard
        image="/imgs/deborahphilips.jpeg"
        name="Deborah Philips"
        testimony={
          "Joining Kuxtech has been a game-changer for me. Their innovative approach to investing and wealth management has provided me with exceptional returns and peace of mind."
        }
      />
      <TestimonialCard
        image="/imgs/johnacker.jpeg"
        name="John Acker"
        testimony={
          "I can't believe how much I've made in just a couple of months. This is definitely the best investment company I've come accross."
        }
      />
      <TestimonialCard
        image="/imgs/fredwalker.jpeg"
        name="Fred Walker"
        testimony={
          "Before I started investing on Kuxtech, I spent alot of money buying hardware/GPU which were expensive even for maintenance. Thank you Kuxtech you're Amazing."
        }
      />
    </div>
  );
}
